import React, { Component } from "react";

class Card extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const { className, children, withoutMargin } = this.props;

		const style = [
			`card-component${withoutMargin ? " card-component--without-margin" : ""}`,
			className
		].join(" ");

		return <div className={style}>{children}</div>;
	}
}

export default Card;
